<template>
  <div :class="$attrs.class">
    <div class="col-12">
      <div class="photo-preview">
        <h2>College Banner</h2>
        <div
          v-if="school.banner.url"
          class="college-banner"
          :style="{ backgroundImage: `url(${school.banner.url})` }"
        />
        <div
          v-else
          class="college-banner default-image"
        />
      </div>
    </div>
    <div class="col-12">
      <input
        id="file"
        ref="filePicker"
        style="display:none;"
        type="file"
        accept="image/*"
        name="file"
        @change="filePickerCallback"
      >

      <button
        type="button"
        @click="openFilePicker()"
        class="btn btn-secondary upload-btn"
      >

        <template v-if="school.saving">
          <font-awesome-icon
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
        </template>
        <template v-else>
          <font-awesome-icon
            :icon="['fas', 'upload']"
          />
          Upload
        </template>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name:'BannerUploader',

  inject: ['school'],

  methods: {
    openFilePicker() {
      this.$refs.filePicker.click();
    },

    async filePickerCallback(event) {
      const files = event.target.files || [];
      const file = files.length ? files[0] : null;

      if (!file) 
        return; 

      try {
        await this.school.updateBanner(file);
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save file. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.upload-btn {
  width: 100%;
  margin-top: 10px;

  i,
  svg {
    margin-right: 7px;
  }
}

.photo-preview {
  .college-banner {
    @include background-cover;
    @include border-radius(100px);
    @include border-radius($border-radius);

    height: 40px;
    width: 40px;
    margin-right: 15px;
    display: inline-block;
    margin-bottom: 15px;
    display: block;
    width: 100%;
    height: 160px;
  }

  h2 {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 0;
    line-height: 40px;
    padding-top: 0;
    margin-top: 0;
    white-space: nowrap;
  }
}

.default-image {
  background-image: url('~@/assets/img/default-banner.jpg');
}
</style>